import DrillStatsPage from '../../../components/DrillStatsPage/DrillStatsPage';

const DrillStats = () => {
  return <DrillStatsPage isRezzilPlayer={true} />;
}

export default DrillStats;
